<div class="snack-bar">
  <img
    *ngIf="type === 'info'"
    src="assets/images/icons/icon-info.svg"
    alt="info"
  />
  <img
    *ngIf="type === 'success'"
    src="assets/images/icons/icon-success.svg"
    alt="success"
  />
  <img
    *ngIf="type === 'error'"
    src="assets/images/icons/icon-error.svg"
    alt="error"
  />
  <p>{{ message }}</p>
  <span (click)="snackBarRef.dismissWithAction()" class="snack-bar__close">
    <img
      *ngIf="type === 'info'"
      src="assets/images/icons/icon-info-close.svg"
      alt="close"
    />
    <img
      *ngIf="type === 'success'"
      src="assets/images/icons/icon-success-close.svg"
      alt="close"
    />
    <img
      *ngIf="type === 'error'"
      src="assets/images/icons/icon-error-close.svg"
      alt="close"
    />
  </span>
</div>
